import MockAdapter from 'axios-mock-adapter';
// 契約企業情報リスト
import companyInfoList from '@/data/companyInfoList.json';
// マスターコード
import mstValue from '@/data/mstValue.json';

let infolist = [
  { no: 1, viewDay: '2022/12/01', infoContent: 'メンテナンスのお知らせ' },
  { no: 2, viewDay: '2023/01/05', infoContent: '2023年のデータ連携に関するお知らせ' },
  { no: 3, viewDay: '2023/02/09', infoContent: 'メンテナンスのお知らせ' },
  { no: 4, viewDay: '2023/03/16', infoContent: 'メンテナンスのお知らせ' },
  { no: 5, viewDay: '2023/04/20', infoContent: 'メンテナンスのお知らせ' },
  { no: 6, viewDay: '2023/05/25', infoContent: '精算のお知らせ' },
  { no: 7, viewDay: '2023/06/29', infoContent: '精算のお知らせ' },
];

let employees = [
  {
    id: 1,
    firstName: '山田',
    lastName: '太郎',
    firstNameKana: 'ヤマダ',
    lastNameKana: 'タロウ',
    dept: '営業',
    tel: '090-1111-2222',
    email: 'shinpei.matsumoto@bbix.net',
  },
  {
    id: 2,
    firstName: '山下',
    lastName: '花子',
    firstNameKana: 'ヤマシタ',
    lastNameKana: 'ハナコ',
    dept: '経理',
    tel: '090-3333-4444',
    email: 'yamashita@test.com',
  },
  {
    id: 3,
    firstName: '岡本',
    lastName: '太郎',
    firstNameKana: 'オカモト',
    lastNameKana: 'タロウ',
    dept: '営業',
    tel: '090-5555-5555',
    email: 'okamoto@taro.com',
  },
  {
    id: 4,
    firstName: '大阪',
    lastName: '良子',
    firstNameKana: 'オオサカ',
    lastNameKana: 'ヨシコ',
    dept: '営業',
    tel: '090-6666-6666',
    email: 'oosaka@yoshi.com',
  },
  {
    id: 5,
    firstName: '櫛勝',
    lastName: '好男',
    firstNameKana: 'クシカツ',
    lastNameKana: 'ヨシオ',
    dept: '経理',
    tel: '090-7777-8888',
    email: 'kushikatsu@test.com',
  },
];

let company =
{
  companyAddressTyuome: 'テスト千葉'
};

let registrationinfolist = [
  {
    corporateCustomerUserId: 1,
    number: 1,
    orderNo: '1111111',
    entruUserNameKanjiSei: '山田',
    entruUserNameKanjiMei: '太郎',
    installationAddressPostalCode: '111-1111',
    installationAddressAddressChome: '東京都港区',
    appliedDate: '2022/10/01',
    constAppointDate: '',
    billingStartDate: '',
    cancelDate: '',
    status: '工事日決定前',
  },
  {
    corporateCustomerUserId: 1,
    number: 2,
    orderNo: '1111112',
    entruUserNameKanjiSei: '山下',
    entruUserNameKanjiMei: '花子',
    installationAddressPostalCode: '111-1112',
    installationAddressAddressChome: '静岡県静岡市',
    appliedDate: '2022/10/01',
    constAppointDate: '2023/01/01',
    billingStartDate: '2023/01/01',
    cancelDate: '',
    status: '開通',
  },
  {
    corporateCustomerUserId: 1,
    number: 3,
    orderNo: '1111113',
    entruUserNameKanjiSei: '岡本',
    entruUserNameKanjiMei: '太郎',
    installationAddressPostalCode: '111-1113',
    installationAddressAddressChome: '山梨県甲府市',
    appliedDate: '2022/10/01',
    constAppointDate: '2023/01/01',
    billingStartDate: '2023/01/01',
    cancelDate: '',
    status: '開通',
  },
  {
    corporateCustomerUserId: 1,
    number: 4,
    orderNo: '1111114',
    entruUserNameKanjiSei: '大阪',
    entruUserNameKanjiMei: '良子',
    installationAddressPostalCode: '111-1114',
    installationAddressAddressChome: '大阪府大阪市北区',
    appliedDate: '2022/10/01',
    constAppointDate: '2023/01/01',
    billingStartDate: '2023/01/01',
    cancelDate: '2023/05/01',
    status: '解約完了',
  },
  {
    corporateCustomerUserId: 1,
    number: 5,
    orderNo: '1111115',
    entruUserNameKanjiSei: '櫛勝',
    entruUserNameKanjiMei: '好男',
    installationAddressPostalCode: '111-1115',
    installationAddressAddressChome: '東京都世田谷区',
    appliedDate: '2022/10/01',
    constAppointDate: '2023/01/01',
    billingStartDate: '2023/01/01',
    cancelDate: '',
    status: '開通',
  },
];

let registrationinfodetail = [
  {
    number: 1,
    companyId: '00001',
    lineId: '000002',
    entryContructFirstName: '東日本',
    entryContructLastName: '太郎',
    entryContructFirstNameKana: 'ヒガシニホン',
    entryContructLastNameKana: 'タロウ',
    entryContactPhone: '090-1111-1111',
    entryEmail: 'test@test',
    item: '10G',
    buildType: 'オフィス',
    curuserPostalCode: '111-1111',
    curuserAddressChome: '東京都港区東新橋１',
    curuserAddressStreet: '１－２',
    curuserAddressBuildin: '東京汐留ビルディング17F',
    surveyRequest: '希望する',
    surveyExecReason: '店舗のオープン日が決まっているため',
    surveyExecReasonDetail: '‐',
    surveyDesiredDate1: '2022/10/01',
    surveyDesiredTime1: '午前（9:00～12:00）',
    surveyDesiredDate2: '2022/10/01',
    surveyDesiredTime2: '午後前半（13:00～15:00）',
    surveyDesiredDate3: '2022/10/03',
    surveyDesiredTime3: '午後後半（15:00～17:00）',
    surveyNotificationRequest: '希望しない',
    constDesiredDate1: '2022/11/05',
    constDesiredTime1: '午前中',
    constDesiredDate2: '2022/12/05',
    constDesiredTime2: '午前中',
    constDesiredDate3: '2023/01/05',
    constDesiredTime3: '午前中',
    witnessKbn: '申込者と異なる',
    witnessFirstName: '中央',
    witnessLastName: '太郎',
    witnessFirstNameKana: 'チュウオウ',
    witnessLastNameKana: 'タロウ',
    witnessType: '設置先住所と異なる',
    sendToFirstName: '中央',
    sendToLastName: '三郎',
    sendToFirstNameKana: 'チュウオウ',
    sendToLastNameKana: 'サブロウ',
    sendToZip: '111-1111',
    sendToAddress1: '千葉県千葉市中央区１',
    sendToAddress2: '１－１',
    sendToAddress3: '',
    squareStyle: '',
    lineStatus: '利用中',
    entryDate: '2022/07/01',
    constAppointDate: '2022/09/01',
    billingDate: '2022/09/01',
    cancelDate: '',
    cancelReceptionDate: '',
    cancelFinishDate: '',
    minumuPeriod: '2024/7',
    repOptionStatus: '利用中',
    repOptionEntryDate: '2022/07/01',
    repOptionCanselDate: '',
    wirelessLanEntryStatus: '未申込',
    wirelessLanEntryDate: '',
    wirelessLancancelDate: '',
    Onu: '機器型番',
    OnuDeliveryDate: '2022/09/01',
    homeGateWay: '機器型番',
    homeGateWayDeliveryDate: '2022/09/01',
  },
  {
    number: 2,
    companyId: '00001',
    lineId: '000002',
    entryContructFirstName: '東日本',
    entryContructLastName: '太郎',
    entryContructFirstNameKana: 'ヒガシニホン',
    entryContructLastNameKana: 'タロウ',
    entryContactPhone: '090-1111-1111',
    entryEmail: 'test@test',
    item: '10G',
    buildType: 'オフィス',
    curuserPostalCode: '111-1111',
    curuserAddressChome: '東京都港区東新橋１',
    curuserAddressStreet: '１－２',
    curuserAddressBuildin: '東京汐留ビルディング17F',
    surveyRequest: '希望する',
    surveyExecReason: '店舗のオープン日が決まっているため',
    surveyExecReasonDetail: '‐',
    surveyDesiredDate1: '2022/10/01',
    surveyDesiredTime1: '午前（9:00～12:00）',
    surveyDesiredDate2: '2022/10/01',
    surveyDesiredTime2: '午後前半（13:00～15:00）',
    surveyDesiredDate3: '2022/10/03',
    surveyDesiredTime3: '午後後半（15:00～17:00）',
    surveyNotificationRequest: '希望しない',
    constDesiredDate1: '2022/11/05',
    constDesiredTime1: '午前中',
    constDesiredDate2: '2022/12/05',
    constDesiredTime2: '午前中',
    constDesiredDate3: '2023/01/05',
    constDesiredTime3: '午前中',
    witnessKbn: '申込者と異なる',
    witnessFirstName: '中央',
    witnessLastName: '太郎',
    witnessFirstNameKana: 'チュウオウ',
    witnessLastNameKana: 'タロウ',
    witnessType: '設置先住所と異なる',
    sendToFirstName: '中央',
    sendToLastName: '三郎',
    sendToFirstNameKana: 'チュウオウ',
    sendToLastNameKana: 'サブロウ',
    sendToZip: '111-1111',
    sendToAddress1: '千葉県千葉市中央区１',
    sendToAddress2: '１－１',
    sendToAddress3: '',
    squareStyle: '',
    lineStatus: '利用中',
    entryDate: '2022/07/01',
    constAppointDate: '2022/09/01',
    billingDate: '2022/09/01',
    cancelDate: '',
    cancelReceptionDate: '',
    cancelFinishDate: '',
    minumuPeriod: '2024/7',
    repOptionStatus: '利用中',
    repOptionEntryDate: '2022/07/01',
    repOptionCanselDate: '',
    wirelessLanEntryStatus: '未申込',
    wirelessLanEntryDate: '',
    wirelessLancancelDate: '',
    Onu: '機器型番',
    OnuDeliveryDate: '2022/09/01',
    homeGateWay: '機器型番',
    homeGateWayDeliveryDate: '2022/09/01',
  },
];

let settlementinfolist = [
  {
    countSettelementMonth: '2023/04',
    countNot10g: '200',
    count10g: '600',
    count24hRepairOption: '600',
    amountNot10g: '1960000',
    amount10g: '300000000',
    amount24hRepairOption: '1980000',
    settlementAmountSummary: '\\303,940,000',
  },
  {
    countSettelementMonth: '2023/03',
    countNot10g: '150',
    count10g: '500',
    count24hRepairOption: '500',
    amountNot10g: '1470000',
    amount10g: '250000000',
    amount24hRepairOption: '1650000',
    settlementAmountSummary: '\\253,120,000',
  },
  {
    countSettelementMonth: '2023/02',
    countNot10g: '100',
    count10g: '400',
    count24hRepairOption: '400',
    amountNot10g: '980000',
    amount10g: '200000000',
    amount24hRepairOption: '1320000',
    settlementAmountSummary: '\\202,300,000',
  },
  {
    countSettelementMonth: '2023/01',
    countNot10g: '60',
    count10g: '300',
    count24hRepairOption: '300',
    amountNot10g: '588000',
    amount10g: '150000000',
    amount24hRepairOption: '990000',
    settlementAmountSummary: '\\151,578,000',
  },
  {
    countSettelementMonth: '2022/12',
    countNot10g: '30',
    count10g: '200',
    count24hRepairOption: '200',
    amountNot10g: '294000',
    amount10g: '100000000',
    amount24hRepairOption: '660000',
    settlementAmountSummary: '\\100,954,000',
  },
  {
    countSettelementMonth: '2022/11',
    countNot10g: '10',
    count10g: '100',
    count24hRepairOption: '100',
    amountNot10g: '98000',
    amount10g: '50000000',
    amount24hRepairOption: '330000',
    settlementAmountSummary: '\\50,428,000',
  },
];

let address =
  [
    {
      addressChome: '千葉県 テスト市',
    },
    {
      addressChome: '新潟県 テスト市',
    }
  ];

let loginUser = {
  loginUser: {
    userNameKanjiSei: '田中',
    userNameKanjiMei: '太郎',
    userNameKanaSei: 'タナカ',
    userNameKanaMei: 'タロウ',
    affiliation: '営業',
    contactPhone: '020-2222-2222',
    authenticationFailNum: '0',
    contactMail: 'test@test.com',
    firstPasswordChange: '1',
    accountLockFlg: '0',
    pwdExpiredFlg: '0',
    userRole: 'ROLE_SELF_USER',
  }
}

let lineList = [
  {
    lineId: 1,
    companyNameKanji: 'BBIX株式会社',
    addressChome: '千代田区',
    contactPhone: '090-1111-2222',
    contactMail: 'test@example.com',
    applicantNameKanjiSei: '田中',
    applicantNameKanjiMei: '太郎',
    entryDate: '2024/01/01',
    constAppointDate: '2024/03/01',
  }
];

let lineDetail = [
  {
    corporateCustomerId: '1',
    lineId: '1',
    applicantNameKanjiSei: '田中',
    applicantNameKanjiMei: '太郎',
    applicantNameKanaSei: 'タナカ',
    applicantNameKanaMei: 'タロウ',
    applicantContactPhone: '090-1111-2222',
    applicantContactMail: 'test@example.com',
    serviceItem: 'テスト品目',
    installationAddressBuildingType: 'テスト建物種別',
    installationAddressPostalCode: '100-0001',
    installationAddressAddressChome: '千代田区',
    installationAddressAddressStreet: '1-1-1',
    installationAddressAddressBuildin: 'テストビルディング101',
    surveyRequest: '有',
    surveyDesiredDate1: '2024-01-01',
    surveyDesiredTime1: '00:00',
    surveyDesiredDate2: '2024-02-01',
    surveyDesiredTime2: '12:00',
    surveyDesiredDate3: '2024-03-01',
    surveyDesiredTime3: '18:00',
    surveyContactDesiredBefore: '有',
    constDesiredDate1: '2024-01-01',
    constDesiredTime1: '00:00',
    constDesiredDate2: '2024-02-01',
    constDesiredTime2: '12:00',
    constDesiredDate3: '2024-03-01',
    constDesiredTime3: '18:00',
    witnessKbn: 'クブン',
    witnessNameKanjiSei: '東京',
    witnessNameKanjiMei: '二郎',
    witnessNameKanaSei: 'トウキョウ',
    witnessNameKanaMei: 'ジロウ',
    witnessContactPhone: '090-2222-3333',
    terminalDestinationNameKbn: 'クブン',
    terminalDestinationNameKanjiSei: '千代田',
    terminalDestinationNameKanjiMei: '三郎',
    terminalDestinationNameKanaSei: 'チヨダ',
    terminalDestinationNameKanaMei: 'サブロウ',
    terminalDestinationAddressKbn: 'クブン',
    terminalDestinationAddressPostalCode: '100-0001',
    terminalDestinationAddressAddressChome: '中央区',
    terminalDestinationAddressAddressStreet: '1-1-1',
    terminalDestinationAddressAddressBuildin: 'テストビルディング202',
    terminalDestinationAddressAddressDetail: 'テスト片書',
    status: '開通',
    entryDate: '2024-01-01',
    constAppointDate: '2024-02-01',
    cancelDate: '2024-03-01',
    cancelEntryDate: '2024-04-01',
    terminationCompletionDate: '2024-05-01',
    businessContractStartDate: '2024-06-01',
    minimumUsagePeriod: '1年',
    repFlg: '開通',
    repEntryDate: '2024-01-01',
    repEndDate: '2024-12-31',
    wirelessLanFlg: '開通',
    wirelessLanEntryDate: '2024-01-01',
    wirelessLanEndDate: '2024-12-31',
    statusValue: '16',
    contractCode: '11111',
    repFlgValue: '0',
    wirelessLanFlgValue: '1',
  }
];

let feeDetail = [
  {
    lineId: '1',
    usageFeeDetailList: [
      {
        settlementMonth: '2024/01',
        billName: '利用料',
        billingAmount: '3000000',
      }
    ]
  }
];

let infoList = {
  infoList: [
    {
      infomationNo: '1',
      displayStartDate: '2024/01/01',
      categoryCode: '101',
      categoryName: 'お知らせカテゴリ',
      subject: 'お知らせタイトル',
      infomationDetail: 'お知らせ本文です1行目\nお知らせ本文です2行目',
    },
    {
      infomationNo: '2',
      displayStartDate: '2024/02/01',
      categoryCode: '102',
      categoryName: 'お知らせカテゴリ2',
      subject: '表示テスト',
      infomationDetail: 'お知らせ本文テスト',
    },
  ]
}; 

function checkRequestUrl(path = '') {
  // ":"から始まる単語構成文字(a-zA-Z_-^9)を"/"を含まない文字列を許容するように置換する
  path = typeof path === 'string'
    ? new RegExp(path.replace(/:\w+/g, '[^/]+'))
    : path
  return path
}

// jsonからcsvに変換(構文破壊対応あり)
function json2Csv(json) {
  var header = ["精算月", "精算対象件数10G以外", "精算対象件数10G", "精算対象件数24時間出張修理OP", "精算金額10G以外", "精算金額10G", "精算金額24時間出張修理OP", "合計(税抜)"].join(',') + "\n";

  var body = json.map(json => {
    json = Object.keys(json).map(key => {
      var field = json[key];
      if (field) {
        field = field.replace(/\r?\n/g, " ");
      }
      return field;
    }).join("\",\"");
    return "\"" + json + "\"";
  }).join("\n");
  return header + body;
}

export default {
  run: client_auth => {
    const mock = new MockAdapter(client_auth);
    mock.onGet('/master').reply(config => {
      return [200, mstValue.find(mst => mst.category == config.params.category && mst.code == config.params.code).values]
    });
    mock.onGet('/infolist').reply(200, infolist);
    mock.onPut('/password').reply(200);
    mock.onGet('/employees').reply(200, employees);
    mock.onGet('/employee').reply(config => {
      return [200, employees.find(e => e.id == config.params.id)]
    });
    mock.onPut('/employee/update/').reply(200);
    mock.onPost('/employee/add/').reply(200);
    mock.onGet('/company').reply(200, company);
    mock.onGet('/companyInfoList').reply(200, companyInfoList);
    mock.onPost('/lineApplication').reply(200, { message: 'OK' });
    mock.onGet('/registrationInfo').reply(200, registrationinfolist);
    mock.onGet(checkRequestUrl('/registrationInfo/detail/:number')).reply(config => {
      var params = config.url.match(/\/registrationInfo\/detail\/(.+)/);
      return [200, registrationinfodetail.find(d => d.number == params[1])]
    });
    mock.onGet('/businessSettlementInfo').reply(200, settlementinfolist);
    mock.onGet('/downloadSettlement').reply(200, json2Csv(settlementinfolist));

    mock.onGet('/address').reply(200, address);
    mock.onPost('/login').reply(200,"",{
        "x-auth-token": "DUMMY_TOKEN",
    });
    mock.onGet('/loginUser').reply(200, loginUser,{"x-auth-token": "DUMMY_TOKEN",});


    mock.onGet('/login-user').reply(200, loginUser, {"x-auth-token": "DUMMY_TOKEN",});
    mock.onGet('/line-contract/list').reply(200, lineList, {"x-auth-token": "DUMMY_TOKEN",});
    mock.onGet(checkRequestUrl('/line-contract/:number')).reply(config => {
      var params = config.url.match(/\/line-contract\/([0-9]+)/);
      return [200, lineDetail.find(d => d.lineId == params[1]), {"x-auth-token": "DUMMY_TOKEN",}]
    });
    mock.onGet(checkRequestUrl('/usage-fee/:number')).reply(config => {
      var params = config.url.match(/\/usage-fee\/([0-9]+)/);
      return [200, feeDetail.find(d => d.lineId == params[1]), {"x-auth-token": "DUMMY_TOKEN",}]
    });
    mock.onGet('/infomation/list').reply(200, infoList, {"x-auth-token": "DUMMY_TOKEN",});
  }
}

